// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__GGpwh","dragIcon":"SortableItem_dragIcon__2oxzq","disabled":"SortableItem_disabled__pqG69"};